import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import DesktopBg from '@/assets/images/Olybet/how-to-play-desktop-bg.png';
import MobileBg from '@/assets/images/Olybet/how-to-play-mobile-bg.png';
import background from '@/assets/images/Olybet/mainBG.png';

import { useSettings } from '@/hooks/useSettings.hook';

import { RoutesEnum } from '@/enums/routes.enum';

import { BANNER_BASE_URL } from '@/utils/constants';

export const StyledBackground = styled('div')(({ theme }) => {
  const { pathname } = useLocation();
  const { isMobile } = useSettings();
  const isOnboardingPage = pathname === RoutesEnum.onboarding;

  const mobileMainBg = `${BANNER_BASE_URL}/global-bg_mobile.png`;
  const desktopMainBg = `${BANNER_BASE_URL}/global-bg_desktop.png`;
  const desktopHowToPlayBg = `${BANNER_BASE_URL}/how-to-play-bg_desktop.png`;
  const mobileHowToPlayBg = `${BANNER_BASE_URL}/how-to-play-bg_mobile.png`;

  const drawBg = () => {
    if (isOnboardingPage) {
      return isMobile ? mobileHowToPlayBg : desktopHowToPlayBg;
    }
    return isMobile ? mobileMainBg : desktopMainBg;
  };
  return {
    backgroundImage: `url(${drawBg()})`,
    backgroundColor: theme.colors.darkBlue,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    position: 'relative',
    backgroundAttachment: 'fixed',
  };
});
